import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomTextField, SectionWrapper } from '@components/Styles/CommonStyle';
import { Checkbox, Button, TableBody, TableHead, Select, MenuItem } from '@mui/material';
import Pagination from '@components/common/Shared/Pagination';
import { CustomSorting } from '@components/Styles/TableStyle';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import React, {useState} from 'react';
import { Typography } from '@mui/material';
import { theme } from '@components/Styles/theme';
import { useNavigate } from 'react-router-dom';
import { businessNoFormatter, formatPhoneNumber } from '@utils/formatter';

const SelfAccountListTable = ({ 
  selfAccountList, 
  selfAccountListTotal, 
  setName, 
  onSearch, 
  onDefaultSearch,
  page, 
  pageSize, 
  setPage,
  setPageSize,
  onDeleteAccount,
  checkedAccountList,
  isCheckboxAllSelect,
  handleCheckboxChange,
  handleCheckAll,
  orderBy,
  setOrderBy,
  orderDir,
  setOrderDir,
}) => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>검색</Typography>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableBody>
              <CustomTableRow>
                <CustomHeaderCell>성명</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomTextField
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onSearch();
                      }
                    }}
                  />
                </CustomBodyCell>
              </CustomTableRow>
            </TableBody>
          </CustomTable>
        </CustomTableContainer>
        <CustomStack justifyContent="center" mt={2}>
          <CustomButton type="search" onClick={onSearch}>
            검색
          </CustomButton>
        </CustomStack>
      </SectionWrapper>

      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>개인 사업자 리스트</Typography>
          <CustomStack justifyContent="spaceBetween" mb={2}>
            <CustomButton onClick={() => navigate('/account/selfAccountCreate')}>신규 등록</CustomButton>
            <CustomButton color="error" onClick={() => {onDeleteAccount();}}>삭제</CustomButton>
          </CustomStack>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableHead>
              <CustomTableRow>
                <CustomHeaderCell align="center">
                  <Checkbox                  
                    checked={isCheckboxAllSelect}    
                    onChange={handleCheckAll}
                    />
                </CustomHeaderCell>
                <CustomHeaderCell align="center">NO</CustomHeaderCell>
                <CustomHeaderCell align="center">
                  성명
                  {
                    orderBy === 'ceo_name' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('ceo_name');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'ceo_name' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('ceo_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('ceo_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  업체명
                  {
                    orderBy === 'company_name' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('company_name');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'company_name' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('company_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('company_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업자번호
                  {
                    orderBy === 'business_no' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_no');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'business_no' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_no');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('business_no');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  신분증
                  {
                    orderBy === 'id_card_url' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('id_card_url');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'id_card_url' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('id_card_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('id_card_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업자등록증
                  {
                    orderBy === 'business_cert_url' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_cert_url');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'business_cert_url' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_cert_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('business_cert_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  통장사본
                  {
                    orderBy === 'bankbook_url' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'bankbook_url' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  휴대전화
                  {
                    orderBy === 'tel' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('tel');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'tel' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('tel');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('tel');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  이메일
                  {
                    orderBy === 'email' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('email');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                    :
                    orderBy === 'email' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('email');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                    :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('email');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {selfAccountList.length > 0 ? (
                selfAccountList.map((item, index) => {
                  return (
                    <CustomTableRow>
                      <CustomBodyCell align="center">
                        <Checkbox
                          checked={checkedAccountList.includes(item.id)}
                          onChange={(e) => handleCheckboxChange(e, item.id )}
                        />
                      </CustomBodyCell>
                      <CustomBodyCell align="center">
                        {selfAccountListTotal - ((page - 1) * pageSize + index)}
                      </CustomBodyCell>
                      <CustomBodyCell align="center">
                        <Button variant="text" 
                          onClick={() => navigate('/account/selfAccountCreate?id='+item.id )}>{item.ceo_name}
                        </Button>
                      </CustomBodyCell>
                      <CustomBodyCell align="center">{item.company_name}</CustomBodyCell>
                      <CustomBodyCell align="center">{businessNoFormatter(item.business_no)}</CustomBodyCell>
                      {
                        item.id_card_url !== null ?
                      <CustomBodyCell align="center">
                        <Button
                          variant="text"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(process.env.REACT_APP_API_URL + item.id_card_url, '_blank');
                          }}
                        >
                          파일보기
                          </Button>
                        </CustomBodyCell> :
                        <CustomBodyCell align="center">
                          -
                        </CustomBodyCell>
                      }
                      {
                        item.business_cert_url !== null ?
                        <CustomBodyCell align="center">
                          <Button
                          variant="text"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(process.env.REACT_APP_API_URL + item.business_cert_url, '_blank');
                          }}
                        >
                          파일보기
                          </Button>
                        </CustomBodyCell> :
                        <CustomBodyCell align="center">
                          -
                        </CustomBodyCell>
                      }
                      {
                        item.bankbook_url !== null ?
                      <CustomBodyCell align="center">
                        <Button
                          variant="text"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(process.env.REACT_APP_API_URL + item.bankbook_url, '_blank');
                          }}
                        >
                          파일보기
                        </Button>
                      </CustomBodyCell> :
                        <CustomBodyCell align="center">
                          -
                        </CustomBodyCell>
                      }
                      <CustomBodyCell align="center">{item.tel ? formatPhoneNumber(item.tel) : '-'}</CustomBodyCell>
                      <CustomBodyCell align="center">{item.email ? item.email : '-'}</CustomBodyCell>
                    </CustomTableRow>
                  );
                })
              ) : (
                <CustomTableRow>
                  <CustomBodyCell colSpan={8} align="center">
                    등록된 개인 사업자가 없습니다.
                  </CustomBodyCell>
                </CustomTableRow>
              )}
            </TableBody>
          </CustomTable>

          <Select
            sx={{ mt: 2, width: '100px', height: '40px' }}
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={30}>30</MenuItem>
          </Select>

          <Pagination count={Math.ceil(selfAccountListTotal / pageSize)} page={page} onChange={onDefaultSearch} />
        </CustomTableContainer>
      </SectionWrapper>
    </React.Fragment>
  );
};

export default SelfAccountListTable;
